import "./App.css";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-HNQB3R1DGC";

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-XXXXXXXXXX');
    `;

    document.head.appendChild(script1);
    document.head.appendChild(script2);
  }, []);
  return (
    <>
      {/* Header / Navigation */}
      <header className="header">
        <div className="header-left"><a href='#top' style = {{fontSize:20}}>Xi (Casey) Chen</a></div>
        <nav className="header-right">
          <a href="#bio">Bio</a>
          <a href="#publications">Publications</a>
          <a href="#working-papers">Working Papers</a>
          <a href="#teaching">Module Convening</a>
        </nav>
      </header>

      {/* Profile Section */}
      <section id = 'top' className="profile">
        <div className="profile-card">
          <div className="profile-image">
            <img src="/profile.jpg" alt="Xi (Casey) Chen" />
          </div>
          <div className="profile-text">
            <h1>Xi (Casey) Chen</h1>
            <p className="title">
              Assistant Professor in Finance<br />
              University of Sussex Business School<br />
              Falmer, Brighton BN1 9SL, UK
            </p>

            <p>
              <strong>Email:</strong> xi.chen@sussex.ac.uk
            </p>

            <p>
              <strong>Research Interests</strong><br />
              Financial Markets, Asset Mispricing, Behavioural Finance,
              Real Options, DeFi and Cryptocurrency, Machine Learning
            </p>

            <p>
              <strong>Transferable Skills</strong><br />
              Python, R, R Shiny, Matlab, Stata<br />
              English (Fluent), Chinese (Native)
            </p>
          </div>
        </div>
      </section>

      {/* Bio */}
      <section id="bio" className="bio">
        <h2>Bio</h2>
        <p>
          Dr. Xi Chen joined the University of Sussex Business School in
          November 2019 as a Lecturer in Finance. Before joining Sussex,
          she obtained her PhD from the ICMA Centre, Henley Business School,
          University of Reading in 2014 under the supervision of Professor
          Carol Alexander and Professor Charles Ward.
        </p>
        <p>
          She subsequently worked at the University of Oxford as a
          (Visiting) Research Associate, and at Oxford Risk Ltd (an Oxford
          University spin-out) as a Behavioural Scientist. Her research
          focuses on generating insights into financial market movements
          and investor activities, and on developing practically
          applicable innovations and technology.
        </p>
      </section>

      {/* Publications */}
      <section id="publications" className="publications">
        <h2>Publications</h2>

        <ul>
          <li>
            Alexander, C., & Chen, X. (2021). <strong>Model risk in real option valuation.</strong>
            <em> Annals of Operations Research</em>, 299, 1025–1056.
          </li>
          <li>
            Alexander, C., Chen, X., & Ward, C. (2021). <strong>Risk-adjusted valuation for real option decisions.</strong>
            <em> Journal of Economic Behavior & Organization</em>, 191, 1046–1064.
          </li>
          <li>
            Alexander, C., Wei, W., & Chen, X. (2024). <strong>Matching Kollo measures.</strong>
            <em> Journal of the Operational Research Society</em>, 75(7), 1279–1293.
          </li>
          <li>
            Alexander, C., Chen, X., Deng, J., & Wang, T. (2024).
            <strong> Arbitrage Opportunities and Efficiency Tests in Crypto Derivatives.</strong>
            <em> Journal of Financial Markets</em>, 71, 100930.
          </li>
          <li>
            Xiong, X., Wang, Z., Chen, X., Knottenbelt, W., & Huth, M. (2025).
            <strong> Leverage Staking with Liquid Staking Derivatives (LSDs): Opportunities and Risks.</strong>
            <em> IEEE Conference on Blockchain and Cryptocurrency (ICBC)</em>.
          </li>
          <li>
            Alexander, C., Chen, X., Deng, J., & Fu, Q. (2025).
            <strong> Price Discovery and Efficiency in Uniswap Liquidity Pools.</strong>
            <em> Journal of Futures Markets</em>.
          </li>
        </ul>
      </section>

      {/* Working Papers */}
      <section id="working-papers" className="working-papers">
        <h2>Working Papers</h2>

        <ul>
          <li>
            Chen, X., McCann, P., & Ward, C.
            <strong> Regional Migration with a Home-Owning Population:
            Option Values of Wealth Accrual and Mobility.</strong>
          </li>
          <li>
            Chen, X., McCann, P., & Ward, C.
            <strong> Regional Migration: A Real-Option Framework.</strong>
          </li>
          <li>
            Alexander, C., Chen, X., & Cumming, D.
            <strong> Coordinated Journals and Citation Patterns.</strong>
          </li>
          <li>
            Alexander, C., Chen, X.
            <strong> Rarity Metrics for Non-Fungible Token Collections.</strong>
          </li>
          <li>
            Chen, X., & Wei, W.
            <strong> Dynamics of Academic Focus in Business Schools.</strong>
          </li>
          <li>
            Zhang, Q., Li, L., Chen, X., & Chen, D.
            <strong> Active Engagement or Information Displacement:
            The Global Impacts of Mandatory Non-Financial Disclosure.</strong>
          </li>
        </ul>
      </section>

      {/* Teaching */}
      <section id="teaching" className="teaching">
        <h2>Module Convening</h2>

        <div className="teaching-grid">
          <div className="teaching-card">
            <h3>FinTech and Financial Transformation</h3>
            <p>
              Formerly <em>Introduction to FinTech</em><br />
              Module developed, UG, Large group<br />
              2019/20 – Now
            </p>
          </div>

          <div className="teaching-card">
            <h3>Portfolio Management</h3>
            <p>
              Module taught, PG, Small group<br />
              2019/20 – 2021/22
            </p>
          </div>

          <div className="teaching-card">
            <h3>Programming in Finance</h3>
            <p>
              Module developed, UG, Large group<br />
              2022/23 – Now
            </p>
          </div>

          <div className="teaching-card">
            <h3>Theory of Investment (Elective)</h3>
            <p>
              Module taught, UG, Large group<br />
              2019/20, 2020/21
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        © {new Date().getFullYear()} Xi Chen
      </footer>
    </>
  );
}

export default App;
